"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    MuiLink: {
        root: {
            fontFamily: theme.typography.fontFamily,
            borderBottom: 'solid 2px',
            paddingBottom: '0.2em',
            color: theme.palette.text.secondary,
            borderColor: theme.palette.text.secondary,
            fontSize: '0.95em',
            cursor: 'pointer',
            '&.MuiLink-underlineHover': {
                textDecoration: 'none',
            },
            '&.MuiLink-underlineHover:hover': {
                textDecoration: 'none',
                color: theme.palette.text.primary,
                borderColor: theme.palette.text.primary,
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGluay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vdmVycmlkZXMvbGluay5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGtCQUFlLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUN2QixPQUFPLEVBQUU7UUFDUCxJQUFJLEVBQUU7WUFDSixVQUFVLEVBQUUsS0FBSyxDQUFDLFVBQVUsQ0FBQyxVQUFVO1lBQ3ZDLFlBQVksRUFBRSxXQUFXO1lBQ3pCLGFBQWEsRUFBRSxPQUFPO1lBQ3RCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxTQUFTO1lBQ25DLFdBQVcsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxTQUFTO1lBQ3pDLFFBQVEsRUFBRSxRQUFRO1lBQ2xCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLDBCQUEwQixFQUFFO2dCQUMxQixjQUFjLEVBQUUsTUFBTTthQUN2QjtZQUNELGdDQUFnQyxFQUFFO2dCQUNoQyxjQUFjLEVBQUUsTUFBTTtnQkFDdEIsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLE9BQU87Z0JBQ2pDLFdBQVcsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxPQUFPO2FBQ3hDO1NBQ0Y7S0FDRjtDQUNGLENBQUMsQ0FBQyJ9